// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__y8d_O","writer-framework-platform":"styles_writer-framework-platform__d5Piv"};